module.exports = __webpack_public_path__ + "static/media/DragDrop.92ff30be.mov";